import React, { useCallback, useState, useEffect, useRef } from 'react';
import style from './InspectionHistory.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import CustomDatePicker from '../../../../components/datepicker/CustomDatePicker';
import { useLocation, useNavigate } from 'react-router-dom';
import URL from '../../../../constants/url';
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';

import Modal from '../../../../components/comm/Modal';
import { formatDateWithWeekday } from '../../../../assets/js/comm';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import Skeleton from '@mui/material/Skeleton';

const PAGE_SIZE = 10;

const InspectionHistory = () => {
    const [displayPeriodText, setDisplayPeriodText] = useState('최근 1년');
    const [selectedPeriod, setSelectedPeriod] = useState('1year'); // '1year', '2year', '3year', 'custom'
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [datePickerType, setDatePickerType] = useState(null); // 'start' or 'end'
    const [mediInfo, setMediInfo] = useState();
    const [hsptlExamRsltList,  setHsptlExamRsltList] = useState([]);

    const navigate = useNavigate();
    const location = useLocation();
   
    const [open, setOpen] = useState(false); // 조회 시트 열기
    const [daySelectOpen, setDaySelectOpen] = useState(false); // 날짜 선택 시트 열기
    const [selectInputValue, setSelectInputValue] = useState(false); // 라디오 버튼 input 값

    const { hsptlCd = "", hsptlNm = "", patntId = "" } = location.state || {};

    const [modalOpen, setModalOpen] = useState(false);  //시작일 > 종료일
    const [modalMessage, setModalMessage] = useState(''); //모달 메세지

    const innerSheetRef = useRef(null); // 바텀시트 내부 ref
    const yearSheetRef = useRef(null); // 일자 조회 ref
    const startSheetRef = useRef(null); // 시작일 ref
    const endSheetRef = useRef(null); // 종료일 ref
    const modalContentRef = useRef(null);

    const observerRef = useRef(null);
    const scrollObserver = useRef(null);
    const [pageNo, setPageNo] = useState(1);
    const [hasNext, setHasNext] = useState(true);

    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [isLoading, setIsLoading] = useState(false); // 상태 추가

    // 페이지 진입 시 스크롤 맨 위로
    useEffect(() => {
        window.scrollTo(0, 0);
        document.getElementById('sub-content')?.scrollTo(0, 0);
    }, []);

    // ✅ pageNo 변경 시 (2 이상) 호출
    useEffect(() => {
        if (pageNo > 1 && hasNext && !isLoadingMore) {
            handleConfirm(pageNo);
        }
    }, [pageNo]);


    // ✅ observer는 데이터가 렌더링된 이후에만 등록
    useEffect(() => {

        if (!hasNext || hsptlExamRsltList.length === 0 || isLoadingMore) return;

        // 기존 observer 제거
        if (scrollObserver.current && observerRef.current) {
            scrollObserver.current.unobserve(observerRef.current);
        }

        scrollObserver.current = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting && !isLoadingMore) {
                setPageNo(prev => prev + 1);
            }
        }, {
            root: null,
            rootMargin: '100px',
            threshold: 1.0
        });

        if (observerRef.current) {
            scrollObserver.current.observe(observerRef.current);
        }

        return () => {
            if (scrollObserver.current && observerRef.current) {
                scrollObserver.current.unobserve(observerRef.current);
            }
        };

    }, [hsptlExamRsltList.length, hasNext, isLoadingMore]);


    const closeModal = () => {
        setModalOpen(false);
        // 모달 닫힌 후 BottomSheet를 다시 열고 싶다면 조금 딜레이를 줌
        setTimeout(() => {
            setOpen(true);
        }, 100); // 100ms 정도면 애니메이션 뒤 열림
    }


    useEffect(() => {

        const today = new Date();

        // 종료일 (오늘)
        const endDt = today.toISOString().slice(0, 10).replace(/-/g, '');
        
        // 시작일 (1년 전)
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(today.getFullYear() - 1);
        const startDt = oneYearAgo.toISOString().slice(0, 10).replace(/-/g, '');        

        setOpen(false);
        setDaySelectOpen(false);

        getClnicInfo(startDt, endDt, 1);

    }, []);



    const getClnicInfo = useCallback(async (start, end, _pageNo=1) => {

        // 이미 로딩 중이면 중복 호출 방지
        if (_pageNo > 1 && isLoadingMore) return;

        // 첫 페이지 로딩 시작
        if (_pageNo === 1) {
            setIsLoading(true);
        } else {
            setIsLoadingMore(true);
        }

        const url = "/hsptl/retrieveHsptlExamRsltInfo";
        const jToken = localStorage.getItem('jToken');
        const reqParam = {
            hsptlCd : hsptlCd, 
            patntId : patntId,
            startDt : start,
            endDt : end,
            pageNo : _pageNo,
            pageSize : PAGE_SIZE
        }

        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
            , withCredentials: true
            , noLoading: true
        }

        await axiosApi.post(url, reqParam, reqOptions)
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const mediInfo = res.data.result;
                setMediInfo({...mediInfo});
                setHsptlExamRsltList(prev => [...prev, ...mediInfo.hsptlExamRsltList]);
                //if (!res.data.result.hasNext) setHasNext(false);
                setHasNext(!!mediInfo.hasNext);   // ✅ true/false를 항상 최신으로 반영

            } else {
                alert(res.data.resultMessage);
            }
        })
        .catch(err => {
            console.error("사용자의료건강정보 호출 중 오류  : ", err);
        })
        .finally(() => {
            if (_pageNo === 1) {
            setIsLoading(false);
            } else {
                setIsLoadingMore(false);  
            }
        });

    }, [navigate]);



    function onDismiss() {
        setOpen(false);
    }

    const openDaySetting = (type) => {
        setDatePickerType(type);
        setOpen(false);
        setDaySelectOpen(true);
    };

    useEffect(() => {
        const today = new Date();
        const end = today;
        let start = new Date(today);

        if (selectedPeriod === '1year') {
            start.setFullYear(today.getFullYear() - 1);
        } else if (selectedPeriod === '2year') {
            start.setFullYear(today.getFullYear() - 2);
        } else if (selectedPeriod === '3year') {
            start.setFullYear(today.getFullYear() - 3);
        } else if (selectedPeriod === 'custom') {
            // If no dates set yet, default to 1 year ago / today or keep existing
            // if (!startDate || !endDate) {
            //     start = new Date(today);
            //     start.setFullYear(today.getFullYear() - 1);
            //     setStartDate(start);
            //     setEndDate(end);
            //     return;
            // } else {
            //     return; // keep existing custom dates
            // }
            return;
        }

        setStartDate(start);
        setEndDate(end);
    }, [selectedPeriod]);

    const formatDate = (date) => {
        if (!date) return '';
        const y = date.getFullYear();
        const m = (date.getMonth() + 1).toString().padStart(2, '0');
        const d = date.getDate().toString().padStart(2, '0');
        return `${y}.${m}.${d}`;
    };

    // CustomDatePicker에서 선택된 날짜를 받아서 startDate 또는 endDate 상태 변경
    const handleDateConfirm = (selectedDate) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // 시간 제거해서 날짜만 비교

       let showModal = false;

        if (datePickerType === 'start') {
            // if (selectedDate > today) {
            //     setModalMessage('시작일을 종료일보다 과거 날짜로 선택해주세요.');
            //     showModal = true;
            // } else if (endDate && selectedDate > endDate) {
            //     setModalMessage('시작일을 종료일보다 과거 날짜로 선택해주세요.');
            //     showModal = true;
            // }

            // 시작일은 종료일과의 비교만 수행 (오늘 이후도 선택 가능)
            if (endDate && selectedDate > endDate) {
                setModalMessage('시작일을 종료일보다 과거 날짜로 선택해주세요.');
                showModal = true;
            }   


            setTimeout(() => {
                if (startSheetRef .current) {
                    startSheetRef .current.focus({ preventScroll: true });
                    startSheetRef .current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 200);
            
        } else if (datePickerType === 'end') {
            if (startDate && selectedDate < startDate) {
                setModalMessage('종료일은 시작일보다 미래 날짜로 선택해주세요.');
                showModal = true;
            }

            setTimeout(() => {
                if (endSheetRef .current) {
                    endSheetRef .current.focus({ preventScroll: true });
                    endSheetRef .current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 200);
        }

        if (showModal) {
            setOpen(false); // BottomSheet 완전히 닫기
            setModalOpen(true);
            return;
        }

        if (datePickerType === 'start') {
            setStartDate(selectedDate);
        } else if (datePickerType === 'end') {
            setEndDate(selectedDate);
        }

        setDaySelectOpen(false);
        setOpen(true); // 다시 기간 선택 BottomSheet 열기
    };

    const handleConfirm = (_pageNo=1) => {
        if (selectedPeriod === 'custom') {
            if (!startDate || !endDate) {
                // 시작일 또는 종료일 선택 안됨
                setModalMessage('시작일과 종료일을 선택해주세요.');
                setOpen(false);
                setModalOpen(true);
                return;
            }

            const diffTime = endDate.getTime() - startDate.getTime();
            const diffDays = diffTime / (1000 * 60 * 60 * 24);
            if (diffDays > (365 * 3) + 1) {
                // 3년 이상 차이
                setModalMessage('시작일을 종료일은 3년 이내로 설정해주세요.');
                setOpen(false);
                setModalOpen(true);
                return;
            }
        }
        if (selectedPeriod === '1year') {
            setDisplayPeriodText('최근 1년');
        } else if (selectedPeriod === '2year') {
            setDisplayPeriodText('최근 2년');
        } else if (selectedPeriod === '3year') {
            setDisplayPeriodText('최근 3년');
        } else if (selectedPeriod === 'custom') {
            setDisplayPeriodText(
                `${formatDate(startDate)} ~ ${formatDate(endDate)}`
            );
        }
        onDismiss();

        if(_pageNo === 1){
            setPageNo(1);
            setHsptlExamRsltList([]);
            setHasNext(true);
        }

        getClnicInfo(formatDate(startDate).replaceAll(".",""), formatDate(endDate).replaceAll(".",""), _pageNo);

        if (_pageNo === 1) {
            setTimeout(() => {
                if (yearSheetRef .current) {
                    yearSheetRef .current.focus({ preventScroll: true });
                    yearSheetRef .current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 200);
        }
    };

    const openPeriodSheet = () => {
        // BottomSheet 열기 전에 현재 displayPeriodText 기준으로 selectedPeriod 세팅
        if (displayPeriodText === '최근 1년') setSelectedPeriod('1year');
        else if (displayPeriodText === '최근 2년') setSelectedPeriod('2year');
        else if (displayPeriodText === '최근 3년') setSelectedPeriod('3year');
        else {
            setSelectedPeriod('custom');
            // custom일 경우 기존 startDate, endDate 유지
        }

        setOpen(true);
    };

    /** iOS 배경 스크롤 방지 */
        useEffect(() => {
            const isAnySheetOpen = open || daySelectOpen || modalOpen;
            if (isAnySheetOpen) {
            document.body.style.overflow = 'hidden';
            document.body.style.touchAction = 'none';
            } else {
            document.body.style.overflow = '';
            document.body.style.touchAction = '';
            }

            return () => {
            document.body.style.overflow = '';
            document.body.style.touchAction = '';
            };
        }, [open, daySelectOpen, modalOpen]);

        /**  딤드 클릭 이벤트 차단용 레이어 */
        const OverlayBlocker = () => {
            // 바텀시트가 열려 있을 때만 클릭 감지
            const handleClick = () => {
                if (open) setOpen(false);
                if (daySelectOpen) setDaySelectOpen(false);
            };

            return (
                <div
                className={`${style['bottomsheet-overlay-block']} ${
                    open || daySelectOpen ? style['active'] : ''
                }`}
                onClick={handleClick} // 클릭 시 닫힘
                />
            );
        };

        // 모달 오픈 시 포커스 이동
        useEffect(() => {
            if (modalOpen && modalContentRef.current) {
                modalContentRef.current.focus({ preventScroll: true });
            }
        }, [modalOpen]);


    return (
        <>
            <HeadSub title="검사 내역" hospitalName={hsptlNm+" 병원"} />

            <div id="sub-content" data-type="b">
                <div className="inner-wrap" data-pad="normal">
                    <div className={style['top-select-box']}>
                        <button
                            className={style['select-day-btn']}
                            ref={yearSheetRef}
                            onClick={()=> {
                                openPeriodSheet();
                                setTimeout(() => {
                                    if (innerSheetRef.current) {
                                        innerSheetRef.current.focus({ preventScroll: true });
                                    }
                                });
                            }}
                        >
                            <span>{displayPeriodText}</span>
                        </button>
                    </div>

                    {
                        isLoading ? 
                            <div className={style['history-list-box']}>
                                <ul>
                                    {[...Array(5)].map((_, index) => (
                                        <li key={`skeleton-${index}`}>
                                            <div className={style['list-box']}>
                                                <div className={style['head']}>
                                                    <strong><Skeleton variant="text" width="100px" height={24} /></strong>
                                                    <p className={style['counter']} style={{width:'60px', height:'20px'}}></p>
                                                </div>
                                                <Skeleton variant="text" width="40%" height={20} />
                                                <Skeleton variant="text" width="60%" height={20} />
                                                
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        : hsptlExamRsltList.length > 0 ?
                            <div className={style['history-list-box']}>
                                <ul>

                                {
                                    hsptlExamRsltList.map((item, index)=>{
                                        return(
                                            <li
                                            onClick={() =>
                                                navigate(URL.HOSPITAL_INSPECTIONDETAIL, {
                                                    state: {
                                                        hsptlCd: hsptlCd,
                                                        patntId: patntId,
                                                        deptCd: item.deptCd,
                                                        testDt: item.testDt
                                                    }                                                                     
                                                })
                                            }
                                        >
                                                <div className={style['list-box']}>
                                                    <div className={style['head']}>
                                                        <strong>{item.clnicDeptNm}</strong>
                                                        <p className={style['counter']}>
                                                            검사 <b>{item.totalCount}</b> 건
                                                        </p>
                                                    </div>
                                                    <p>{item.doctrNm} 교수</p>
                                                    <p className={style['pill-element']}>
                                                        {item.prscrptnTestCtgrNm}
                                                    </p>
                                                    <span>{formatDateWithWeekday(item.testDt)}</span>
                                                </div>
                                            </li>            
                                        )
                                    })
                                }
                                </ul>

                                {/* 더 로딩 중일 때 표시 */}
                                {isLoadingMore && (
                                    <div className={style['history-list-box']}>
                                        <ul>
                                            <li>
                                                <div className={style['list-box']}>
                                                    <div className={style['head']}>
                                                        <strong><Skeleton variant="text" width="100px" height={24} /></strong>
                                                        <p className={style['counter']} style={{width:'60px', height:'20px'}}></p>
                                                    </div>
                                                    <Skeleton variant="text" width="40%" height={20} />
                                                    <Skeleton variant="text" width="60%" height={20} />
                                                    
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                )}

                                {hasNext && <div ref={observerRef} style={{ height: '1px' }} />}

                            </div>
                        :
                            <div className={style['no-data-box']}>
                                <span>검사 내역이 없습니다.</span>
                            </div>                        
                    }
                    {!modalOpen && (
                    <BottomSheet

                        scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                        expandOnContentDrag={false} // 내용 드래그로 확장 방지
                
                        open={open}
                        onDismiss={onDismiss}
                        snapPoints={({ minHeight }) => minHeight}
                        blocking={true}
                    >
                        <div className={style['content-wrap']}>
                            <div className={style['inner-box']} ref={innerSheetRef} tabIndex={0}>
                                <div className={style['select-period-box']}>
                                    <strong>조회 기간</strong>
                                    <ul>
                                        <li>
                                            <div
                                                className="radio-selectbox"
                                                data-style="b"
                                                aria-pressed={selectedPeriod === '1year'}
                                                aria-label={selectedPeriod === '1year' ? '1년 선택됨' : '1년 선택하기'}
                                                tabIndex={-1}
                                            >
                                                <input
                                                    type="radio"
                                                    id="year1"
                                                    name="year-select"
                                                    value="1year"
                                                    checked={
                                                        selectedPeriod ===
                                                        '1year'
                                                    }
                                                    onChange={(e) =>
                                                        setSelectedPeriod(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                                <label htmlFor="year1" aria-hidden={true}>
                                                    <span>1년</span>
                                                </label>
                                            </div>
                                        </li>
                                        <li>
                                            <div
                                                className="radio-selectbox"
                                                data-style="b"
                                                aria-pressed={selectedPeriod === '2year'}
                                                aria-label={selectedPeriod === '2year' ? '2년 선택됨' : '2년 선택하기'}
                                                tabIndex={-1}
                                            >
                                                <input
                                                    type="radio"
                                                    id="year2"
                                                    name="year-select"
                                                    value="2year"
                                                    checked={
                                                        selectedPeriod ===
                                                        '2year'
                                                    }
                                                    onChange={(e) =>
                                                        setSelectedPeriod(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                                <label htmlFor="year2" aria-hidden={true}>
                                                    <span>2년</span>
                                                </label>
                                            </div>
                                        </li>
                                        <li>
                                            <div
                                                className="radio-selectbox"
                                                data-style="b"
                                                aria-pressed={selectedPeriod === '3year'}
                                                aria-label={selectedPeriod === '3year' ? '3년 선택됨' : '3년 선택하기'}
                                                tabIndex={-1}
                                            >
                                                <input
                                                    type="radio"
                                                    id="year3"
                                                    name="year-select"
                                                    value="3year"
                                                    checked={
                                                        selectedPeriod ===
                                                        '3year'
                                                    }
                                                    onChange={(e) =>
                                                        setSelectedPeriod(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                                <label htmlFor="year3" aria-hidden={true}>
                                                    <span>3년</span>
                                                </label>
                                            </div>
                                        </li>
                                        <li>
                                            <div
                                                className="radio-selectbox"
                                                data-style="b"
                                                aria-pressed={selectedPeriod === 'custom'}
                                                aria-label={selectedPeriod === 'custom' ? '직접입력 선택됨' : '직접입력 선택하기'}
                                                tabIndex={-1}
                                            >
                                                <input
                                                    type="radio"
                                                    id="custom"
                                                    name="year-select"
                                                    value="custom"
                                                    checked={
                                                        selectedPeriod ===
                                                        'custom'
                                                    }
                                                    onChange={(e) => {
                                                        setSelectedPeriod(e.target.value);
                                                        setStartDate(null); // placeholder 보이게 초기화
                                                        setEndDate(null);   // placeholder 보이게 초기화
                                                    }}
                                                />
                                                <label htmlFor="custom" aria-hidden={true}>
                                                    <span>직접입력</span>
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                <div className={style['select-day-box']}>
                                    <strong>시작일</strong>
                                    <div className="input-box" data-type="d" ref={startSheetRef} tabIndex={1}>
                                        {selectInputValue ? (
                                            <input
                                                type="button"
                                                inputmode="none"
                                                id="pill-name"
                                                placeholder="시작일 선택"
                                                onClick={() => openDaySetting()}
                                            />
                                        ) : (
                                            <input
                                                type="button"
                                                inputMode="none"
                                                value={startDate ? formatDate(startDate) : ""}
                                                className={`${style['no-select']} ${!startDate ? style['placeholder-active'] : ''}`}
                                                onFocus={(e) => e.target.blur()}
                                                placeholder="시작일 선택"
                                                readOnly
                                                disabled={
                                                    selectedPeriod !== 'custom'
                                                }
                                                onClick={() => {
                                                    if (
                                                        selectedPeriod ===
                                                        'custom'
                                                    )
                                                        openDaySetting('start');
                                                }}
                                            />
                                        )}
                                        <span className={style['placeholder-box']}>시작일 선택</span>
                                    </div>
                                </div>

                                <div className={style['select-day-box']}>
                                    <strong>종료일</strong>
                                    <div className="input-box" data-type="d" ref={endSheetRef} tabIndex={0}>
                                        {selectInputValue ? (
                                            <input
                                                type="button"
                                                inputmode="none"
                                                id="pill-name"
                                                placeholder="종료일 선택"
                                                value=""
                                                onClick={() => openDaySetting()}
                                            />
                                        ) : (
                                            <input
                                                type="button"
                                                inputMode="none"
                                                value={endDate ? formatDate(endDate) : ""}
                                                placeholder="종료일 선택"
                                                className={`${!endDate ? style['placeholder-active'] : ''}`}
                                                readOnly
                                                disabled={
                                                    selectedPeriod !== 'custom'
                                                }
                                                onClick={() => {
                                                    if (
                                                        selectedPeriod ===
                                                        'custom'
                                                    )
                                                        openDaySetting('end');
                                                }}
                                            />
                                        )}
                                        <span className={style['placeholder-box']}>종료일 선택</span>
                                    </div>
                                </div>

                                <div className={style['bottom-box']}>
                                    <button
                                        className="btn"
                                        data-btn-type="fill-main"
                                        data-btn-size="lg"
                                        onClick={()=>{
                                            handleConfirm();
                                        }}
                                    >
                                        <span>확인</span>
                                    </button>
                                </div>

                                <button
                                    className={style['close-btn']}
                                    onClick={()=> {
                                        onDismiss();
                                        setTimeout(() => {
                                            if (yearSheetRef .current) {
                                                yearSheetRef .current.focus({ preventScroll: true });
                                                yearSheetRef .current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                            }
                                        }, 200);
                                    }}
                                >
                                    <span className="blind">팝업 닫기</span>
                                </button>
                            </div>
                        </div>
                    </BottomSheet>
                    )}

                    <BottomSheet

                        scrollLocking={true} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                        expandOnContentDrag={false} // 내용 드래그로 확장 방지

                        open={daySelectOpen}
                        onDismiss={() => setDaySelectOpen(false)}
                        snapPoints={({ minHeight }) => minHeight}
                        blocking={true}
                    >
                        <CustomDatePicker
                            type={datePickerType}
                            titleTxt={datePickerType === 'start' ? '시작일 선택' : '종료일 선택'}
                            onClose={() => {
                                setDaySelectOpen(false);
                                setOpen(true);

                                setTimeout(() => {
                                // datePickerType이 start이면 startSheetRef, 아니면 endSheetRef로 포커스 복귀
                                const targetRef =
                                    datePickerType === 'start' ? startSheetRef : endSheetRef;

                                if (targetRef?.current) {
                                    targetRef.current.focus({ preventScroll: true });
                                    targetRef.current.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'center',
                                    });
                                }
                                }, 200);
                            }}
                            onConfirm={handleDateConfirm}
                        />
                    </BottomSheet>

                    {/* 딤드 클릭 차단용 레이어 */}
                    <OverlayBlocker />

                    <Modal isOpen={modalOpen} setIsOpen={setModalOpen} ref={modalContentRef} tabIndex={-1}>
                        <div className='modal-box' data-type="a">
                            <div className='modal-top-box'>
                                <div className='title-box'>
                                    <p>{modalMessage}</p>
                                </div>
                            </div>

                            <div className="modal-bottom-box"> 
                                <div className='btn-layout'>
                                    <button className="btn" data-btn-type="fill-main" data-btn-size="md" onClick={closeModal}>
                                        <span>확인</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Modal>             

                </div>
            </div>
        </>
    );
};

export default InspectionHistory;
